document.addEventListener("DOMContentLoaded", function() {
    // Find the 'Accessibility Statement' link
    const accessibilityLink = document.querySelector('a[href="/pages/shop-zollipops-zom-accessibility-statement"]');
  
    // Check if the element exists before adding an ID
    if (accessibilityLink) {
      // Assign a unique ID to the link
      accessibilityLink.setAttribute('id', 'accessibility-link');
    }
  });

  //back to top
  jQuery(document).ready(function() {
    var backToTopButton = jQuery('#back-to-top');
    
    jQuery(window).scroll(function() {
        if (jQuery(this).scrollTop() > 300) {
            backToTopButton.show();
        } else {
            backToTopButton.hide();
        }
    });
    
    backToTopButton.on('click', function(e) {
        e.preventDefault();
        jQuery('html, body').animate({ scrollTop: 0 }, 'slow');
        
        // Set focus to the top of the page or the button itself after scrolling
        setTimeout(function() {
            // jQuery('#backtoheader').focus(); // If focusing the top element
            // backToTopButton.focus(); // If focusing the button itself
        }, 600); // Adjust the timeout duration to match the scroll duration
    });
});


//contact us third party


document.querySelector('.add-to-cart-btn').addEventListener('click', function (event) {
    // Assuming the popup becomes visible after the Add to Cart button is clicked
    setTimeout(() => {
      const popup = document.querySelector('.your-popup-class'); // Replace with actual popup class
      if (popup) {
        popup.setAttribute('tabindex', '-1'); // Make popup focusable
        popup.setAttribute('aria-live', 'assertive'); // Notify screen reader
        popup.focus(); // Move focus to popup
      }
  
      // Optional: Announce product added to cart, if necessary for screen reader
      const liveRegion = document.querySelector('#live-region');
      if (liveRegion) {
        liveRegion.textContent = 'Product added to cart!'; // Screen reader announcement
      }
    }, 100); // Delay to allow popup rendering
  });



//external links
$('a[href="https://www.iherb.com/c/zollipops"]').attr('aria-label','For delivery outside the Continental U.S visit iHerb.com, This link will open in a new tab');
$('a[href="https://zollipops.com/contact-us/"]').attr('aria-label','Contact us, this link will open in a new tab');

$('a[href="https://www.iherb.com/c/zollipops"]')
    .attr('aria-label', 'For delivery outside the Continental U.S visit iHerb.com, This link will open in a new tab')
    .attr('target', '_blank');

$('a[href="https://zollipops.com/contact-us/"]')
    .attr('aria-label', 'Contact us, this link will open in a new tab')
    .attr('target', '_blank');

    
// 11-OcT-2024




$(document).ready(function () {
  setTimeout(function () {
    $('.card__surface.p-5 .inline-rte a').each(function() {
      var title = $(this).attr('title'); // Get the title attribute
      if (title) {
          $(this).attr('aria-label', title); // Set aria-label with the same value as title
      }
    });

}, 3000);
}, 3000);

$(document).ready(function() {


  // $('.card__surface.p-5 .inline-rte a').each(function() {
  //   var title = $(this).attr('title'); // Get the title attribute
  //   if (title) {
  //       $(this).attr('aria-label', title); // Set aria-label with the same value as title
  //   }
  // });


});

document.addEventListener('DOMContentLoaded', function() {
  var anchors = document.querySelectorAll('.card__surface.p-5 .inline-rte a');

  anchors.forEach(function(anchor) {
    var title = anchor.getAttribute('title'); // Get the title attribute
    if (title) {
      anchor.setAttribute('aria-label', title); // Set aria-label with the same value as title
    }
  });
});


// CART Button Focus Issue Jquery
var lastFocusedButton;
$("div#cart-popup button#CartButton").on("click", function () {
  lastFocusedButton = jQuery(this); // Save the last focused button
  setTimeout(function () {
    $("button.top-0.block.close").attr("tabindex", 0).focus(); 
	  // Set focus on the close button
  }, 1000);
});
// Close the popup and return focus to the last focused button
$("button.top-0.block.close").on("click", function () {
  setTimeout(function () {
    if (lastFocusedButton) {
      lastFocusedButton.attr("tabindex", 0).focus(); // Return focus to the last focused button
    }
  }, 1000);
});

// Search Button Focus Issue Jquery
$(".flex.p-1").on("click", function () {
  setTimeout(function () {
    $("div#search-popup a.font-heading.uppercase.h-full.flex.items-center ").first().attr("tabindex", 0).focus();
  }, 1000);
});

